import React from 'react';
import Modal from 'react-modal';
import { Link } from 'react-router-dom';
import { X } from 'react-feather';
import Slider from 'react-slick';

import { BASE_URL } from '../../data/imageList';
import Logo from '../../assets/images/my-name.png';

Modal.setAppElement('#root');

const SliderModal = (props) => {
  const sliderSettings = {
    dots: true,
    fade: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1
  };

  const style = {
    overlay: {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(255, 255, 255, 0.75)',
      zIndex: 1000
    },
    content: {
      position: 'absolute',
      top: '0px',
      left: '0px',
      right: '0px',
      bottom: '0px',
      border: 'none',
      background: '#101015',
      overflow: 'hidden',
      WebkitOverflowScrolling: 'touch',
      outline: 'none',
      padding: '0px'
    }
  };

  const images = props.images;

  return (
    <Modal
      {...props} 
      className="modal-overlay" 
      id="feature-modal" 
      style={style}
    >
      <div className="shell">
        <nav className="header">
          <div className="header__left">
            <div className="header__logo-wrapper valign-wrapper center-text">
              <Link className="valign-wrapper" to="/">
                <img className="header__logo" src={Logo} alt="Debashish Nayak" />
              </Link>
            </div>
          </div>
          <div className="header__right">
            <div className="valign-wrapper flex-end">
              <a onClick={props.onRequestClose} className="strike-through">
                <X className="float-right" size={28} />
              </a>
            </div>
          </div>
        </nav>
        <div className="main">
          <Slider
            {...sliderSettings}
          >
            {
              images.list.map((image, index) => {
                const URL = `${BASE_URL + images.folder}/${image}`;
                
                return (
                  <div key={index}>
                    <img src={URL} alt={image} />
                  </div>
                );
              })
            }
          </Slider>
        </div>
      </div>
    </Modal>
  );
};

export default SliderModal;


// WEBPACK FOOTER //
// ./src/components/Common/SliderModal.js